import { Card, CardHeader } from "../Form.Status/Status.styled";
import CloseIcon from "../../assets/CloseIcon.svg";
import { FC, ReactElement, useRef, useState } from "react";
import CardContent from "@mui/material/CardContent";
import { Label } from "../../screens/complaint/Complaint.styled";
import { ButtonSecondary } from "../../screens/login.screen/login.styled";
import SecondPopup from "./SecondPopup";
import { PopupData } from "./Tabs.styled";
import General from '../../stores/GeneralStore'
import { observer } from "mobx-react";

interface Obj {
  [key: string]: any;
}

interface Props {
  account: Obj | null,
  onCloseClick: () => void,
  addAccount: (account: Obj) => void,
  searchClicked: (accountNumber: string) => void,
}

const AccountPopup: FC<Props> = ({ account, addAccount, onCloseClick, searchClicked }: Props): ReactElement => {

  const accountNumberRef = useRef<HTMLInputElement>(null)

  const searchForAccount = () => {

    if (accountNumberRef.current?.value != null)
      searchClicked(accountNumberRef.current?.value)

    //setFound(true)
  }

  const handleAddAccount = () => {
    if (account)
      addAccount(account)
  }


  return (
    <Card style={{
      width: "640px",
    }}>
      <CardHeader
        style={{
          height: "92px",
          justifyContent: "space-between",
          paddingLeft: "1rem",
          paddingRight: "20px",
        }}
      >
        <h1 style={{ color: "#fff", justifySelf: "flex-start", fontWeight: "400", fontSize: "40px", fontStyle: "normal", padding: "20px" }}>
          {General?.codeLabels["cm_pdc_addaccount"]?.label !== undefined ? General?.codeLabels["cm_pdc_addaccount"]?.label : "Add Account"}
        </h1>
        <img src={CloseIcon} alt="" onClick={onCloseClick} />
      </CardHeader>
      {!account ? <CardContent sx={{ display: "flex", alignItems: "center", background: "#fff", width: "100%", }}>
        <Label style={{ fontWeight: "800", width: "100%", }}>
          {General?.codeLabels["cm_accountid"]?.label !== undefined ? General?.codeLabels["cm_accountid"]?.label : "Account Number"}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              width: "100%",
              height: "150px",
              justifyContent: "center",
              gap: "1rem",
            }}
          >
            <input
              className="DynamicInput"
              type="text"
              placeholder="Type here"
              ref={accountNumberRef}
              style={{ background: "#edf4f6", paddingLeft: "0.5rem", width: "330px", height: "46px" }}
            />
            <ButtonSecondary
              style={{
                background: "#101e8e",
                color: "#fff",
                width: "179px",
                height: "50px",
              }}
              onClick={searchForAccount}
            >
              {General?.codeLabels["cm_search"]?.label !== undefined ? General?.codeLabels["cm_search"]?.label : "SEARCH"}
            </ButtonSecondary>
          </div>
        </Label>
      </CardContent>
        : <CardContent
          sx={{
            background: "#fff",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            color: General?.contrast?.contrastColor ? General.contrast.contrastColor : General.ColorAss
          }}
        >
          <PopupData>
            <span>
              {General?.codeLabels["cm_pdc_premisedetails"]?.label !== undefined ? General?.codeLabels["cm_pdc_premisedetails"]?.label : "Premise Details"}
            </span>
            <span>{account.premiseAddress}</span>
          </PopupData>
          <br />
          <PopupData>
            <span>
              {General?.codeLabels["cm_accountnobillstable"]?.label !== undefined ? General?.codeLabels["cm_accountnobillstable"]?.label : "Account Number"}
            </span>
            <span>{account.accountId}</span>
          </PopupData>
          <br />
          <PopupData>
            <span>
              {General?.codeLabels["cm_premiseid"]?.label !== undefined ? General?.codeLabels["cm_premiseid"]?.label : "Sewerage Number"}
            </span>
            <span>{account.premiseId}</span>
          </PopupData>
          <br />
          <PopupData>
            <span>
              {General?.codeLabels["cm_dpremiseusage"]?.label !== undefined ? General?.codeLabels["cm_dpremiseusage"]?.label : "Premise Usage"}
            </span>
            <span>{account.propertyUsage}</span>
          </PopupData>
          <br />
          <PopupData>
            <span>{General?.codeLabels["cm_amt_due"]?.label !== undefined ? General?.codeLabels["cm_amt_due"]?.label : "Amount Due"}(AED)</span>
            <span>{(Number(account.serviceFee) + Number(account.vatCharges)).toFixed(2)}</span>
          </PopupData>
          <br />
          <hr style={{ width: "574px", height: "1px", mixBlendMode: "normal", opacity: "0.2", background: "#101E8E", marginBottom: "10px", marginTop: "10px" }}></hr>
          <ButtonSecondary
            style={{
              width: "50%",
              background: "#101e8e",
              color: "#fff",
              padding: "10px",
            }}
            onClick={handleAddAccount}
          >
            {General?.codeLabels["cm_pdc_addaccount"]?.label ? General?.codeLabels["cm_pdc_addaccount"]?.label : "Add Account"}
          </ButtonSecondary>
        </CardContent>

      }
    </Card>
  );
};

export default observer(AccountPopup);
